<template>
  <div :class="(compact) ? 'NavigationTabs-styles-compact' :'timer-tab'" class="NavigationTabs-styles-navigation-tabs">
    <button @click="changePeriod(p.p)" v-for="p in periods" :class="(timeperiod === p.p) ? 'TabButton-styles-tab-button-active NavigationTabs-styles-active' : (compact) ? 'NavigationTabs-styles-hidden' : ''" testid="Button_tab_button_all" id="tab-button-all" class="Button-styles-button TabButton-styles-tab-button TabButton-styles-tab-button-full-width NavigationTabs-styles-filter-button">
      <div class="">{{ p.n }}</div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'timer',
  data () {
    return {
      compact: false,
      t: this.$root.t,
      timeperiod: '',
      periods: [
        {n: t.all, p: ''},
        {n: t.sportsbook.filter.today, p: 'today'},
        {n: t.sportsbook.filter['2h'], p: '2 hours'},
        {n: t.sportsbook.filter['48h'], p: '48 hours'},
      ]
    }
  },
  watch: {
    'timeperiod' () {
      this.$store.commit("updateFixtureTimeperiod", this.timeperiod);
    }
  },
  mounted() {
    var th = this
    this.$bus.$on('compact', (payload) => {

      th.compact = payload;

    });
  },
  methods: {
    changePeriod (p) {
      this.timeperiod = p
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget/timer.vue